<div
  class="vk-auth tw-relative tw-flex tw-size-full tw-mx-auto tw-flex-col"
  style="background: var(--vk-paper); color: var(--vk-ink); font-family: var(--font-sans);"
  [class]="{
    'tw-min-h-screen': clientType === 'web',
    'tw-min-h-full': clientType === 'browser' || clientType === 'desktop',
    'vk-auth--compact': clientType === 'browser',
  }"
>
  <ng-content select="bit-landing-header"></ng-content>
  <main class="tw-relative tw-flex tw-flex-1 tw-size-full tw-mx-auto tw-flex-col">
    <ng-content></ng-content>
  </main>
  <ng-content select="bit-landing-footer"></ng-content>
</div>
